<template>
  <header class="sticky top-0 z-50 bg-white shadow-sm">
    <!-- 桌面端 Top Bar（联系方式） -->
    <div class="hidden lg:block bg-dark-bg text-white text-sm">
      <div class="max-w-6xl mx-auto px-4 lg:px-8">
        <div class="flex items-center justify-between py-2">
        <div class="flex items-center space-x-6">
        <span class="flex items-center gap-1"><i class="text-accent">📞</i> 18027254019</span>
        <span class="flex items-center gap-1"><i class="text-accent">✉</i> nicolasfranchet@gmail.com</span>
        <span class="flex items-center gap-1"><i class="text-accent">📍</i> 广东省广州市番禺区</span>
      </div>
      <a href="tel:+8618027254019" class="bg-primary hover:bg-primary-dark text-white px-4 py-1 rounded text-sm transition-colors">联系我们</a>
        </div>
      </div>
    </div>

    <!-- 主导航栏 -->
    <div class="w-full bg-white">
      <div class="max-w-6xl mx-auto px-4 lg:px-8">
        <div class="flex items-center h-14 lg:h-[72px]">
      <!-- Logo -->
      <router-link to="/index" class="flex-shrink-0">
        <img src="@/assets/logo.png" alt="BERLIN SHELVES" class="h-8 lg:h-10 w-auto">
      </router-link>

      <!-- 桌面端水平导航（居中） -->
      <nav class="hidden lg:flex items-center justify-end flex-1">
        <div class="flex items-center space-x-1">
        <router-link
          v-for="item in navItems"
          :key="item.path"
          :to="item.path"
          class="px-4 py-2 text-lg rounded transition-colors"
          :class="$route.path === item.path ? 'text-primary-dark font-bold' : 'text-gray-700 hover:text-primary'"
        >{{ item.label }}</router-link>
        </div>
      </nav>

      <!-- 移动端汉堡按钮 -->
      <button
        class="lg:hidden flex items-center justify-center w-11 h-11 rounded text-gray-700 hover:bg-gray-100 transition-colors"
        @click="drawerVisible = true"
        aria-label="打开菜单"
      >
        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"/>
        </svg>
      </button>
      </div>
      </div>
    </div>

    <!-- 移动端导航抽屉 -->
    <el-drawer
      v-model="drawerVisible"
      direction="rtl"
      size="80%"
      :with-header="false"
    >
      <div class="flex flex-col h-full pt-12">
        <button
          class="absolute top-4 right-4 w-10 h-10 flex items-center justify-center rounded-full hover:bg-gray-100 transition-colors"
          @click="drawerVisible = false"
        >
          <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
          </svg>
        </button>

        <router-link
          v-for="item in navItems"
          :key="item.path"
          :to="item.path"
          class="block px-4 py-4 text-xl border-b border-gray-100 transition-colors"
          :class="$route.path === item.path ? 'text-primary-dark font-bold bg-gray-50' : 'text-gray-700'"
          @click="drawerVisible = false"
        >{{ item.label }}</router-link>

        <div class="mt-auto px-4 py-6 text-sm text-gray-500 space-y-2">
          <p>📞 18027254019</p>
          <p>✉ nicolasfranchet@gmail.com</p>
          <p>📍 广东省广州市番禺区</p>
        </div>
      </div>
    </el-drawer>
  </header>
</template>

<script>
export default {
  name: "CommonHeader",
  data() {
    return {
      drawerVisible: false,
      navItems: [
        { path: '/index', label: 'Home' },
        { path: '/product', label: 'Products' },
        { path: '/about', label: 'About Us' },
        { path: '/blog', label: 'Blog' },
        { path: '/contactUs', label: 'Contact Us' },
      ]
    }
  }
}
</script>
